/**
 * @generated SignedSource<<8ceedf9ab28fb2959611048de7d41647>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CarryForward_note$data = {
  readonly actionItemsCarriedForward: boolean;
  readonly id: string;
  readonly previousNote: {
    readonly pendingAgendaCount: number;
    readonly pendingTodoCount: number;
  } | null;
  readonly stream: {
    readonly carryActionItems: boolean | null;
    readonly carryTalkingPoints: boolean | null;
  };
  readonly talkingPointsCarriedForward: boolean;
  readonly " $fragmentType": "CarryForward_note";
};
export type CarryForward_note$key = {
  readonly " $data"?: CarryForward_note$data;
  readonly " $fragmentSpreads": FragmentRefs<"CarryForward_note">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CarryForward_note",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actionItemsCarriedForward",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "talkingPointsCarriedForward",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "stream",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "carryActionItems",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "carryTalkingPoints",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Note",
      "kind": "LinkedField",
      "name": "previousNote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingAgendaCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pendingTodoCount",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Note",
  "abstractKey": null
};

(node as any).hash = "04b792f94d622c9b00437b73d5046afd";

export default node;
